import { useQuery } from "@tanstack/react-query";
import { getPodcasts } from "@/services/podcastService";
import PodcastCard from "@/components/podcast/PodcastCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Input } from "@/components/ui/input";
import { Search, Mic } from "lucide-react";
import { useState } from "react";
import { PageHeader } from "@/components/ui/page-header";
import { EmptyState } from "@/components/ui/empty-state";
import { PageShell } from "@/components/layout/PageShell";
import Seo from "@/components/seo/Seo";
import { useLocale } from "@/i18n/useLocale";
import { useT } from "@/i18n/useLocale";

const Podcasts = () => {
  const t = useT();
  const [searchQuery, setSearchQuery] = useState("");

  const locale = useLocale();
  const { data: podcasts, isLoading } = useQuery({
    queryKey: ["podcasts", locale],
    queryFn: () => getPodcasts(locale),
  });

  const filteredPodcasts = podcasts?.filter(
    (podcast) =>
      podcast.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      podcast.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      podcast.author?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Seo
        title={t("auto.podcasts-byteline-6720")}
        description={t("auto.discover-and-listen-to-the-sharpest-show-3071")}
        path="/podcasts"
      />
      <PageShell>
      <PageHeader
        eyebrow={t("auto.audio-b22f")}
        title={t("auto.podcasts-9bf7")}
        description={t("auto.discover-and-listen-to-the-sharpest-show-3071")}
        actions={
          <div className="relative w-full md:w-72">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              placeholder={t("auto.search-podcasts-f4ab")}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10"
              aria-label={t("auto.search-podcasts-11ca")}
            />
          </div>
        }
      />

      {isLoading ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="space-y-3">
              <Skeleton className="aspect-square w-full" />
              <Skeleton className="h-6 w-3/4" />
              <Skeleton className="h-4 w-full" />
            </div>
          ))}
        </div>
      ) : filteredPodcasts && filteredPodcasts.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {filteredPodcasts.map((podcast) => (
            <PodcastCard key={podcast.id} podcast={podcast} />
          ))}
        </div>
      ) : (
        <EmptyState icon={Mic} title={t("auto.no-podcasts-found-39d2")} description={t("auto.try-a-different-search-term-7f51")} />
      )}
      </PageShell>
    </>
  );
};

export default Podcasts;

